<div class="row height-100 m-0">
  <div class="col p-0 height-100">
    <lib-prod-header [title]="formTitle">
      <dip-grid-filter-form [deletedFilters$]="deletedFilters$"></dip-grid-filter-form>
    </lib-prod-header>
  </div>
  <div class="col p-0 height-100 ">
    <lib-prod-header [title]="privateFiltersTitle">
      <div class="grid-wrapper">
        <mat-selection-list #filters style="height: 91%; overflow: auto;">
          <mat-list-option *ngFor="let clientFilter of filterList(true)" [value]="clientFilter.id">
            {{clientFilter.name}}
          </mat-list-option>

          <div class="prod-header-title">
            <div>
              <span>{{'&nbsp;' + publicFiltersTitle}}</span>
            </div>
          </div>

          <mat-list-option *ngFor="let clientFilter of filterList(false)" [value]="clientFilter.id"
                           [disabled]="!canDeletePublicFilter">
            {{clientFilter.name}}
          </mat-list-option>
        </mat-selection-list>
        <div class="filter-dialog-bbar mt-auto" layout="row" align="end">
          <button
            class="ml-1"
            mat-button
            mat-stroked-button
            (click)="deleteFilters(filters.selectedOptions.selected)"
            type="button"><i class="fa fa-trash-o"></i>&nbsp;
            Delete selected filters ({{filters.selectedOptions.selected.length}})
          </button>
        </div>
      </div>
    </lib-prod-header>
  </div>
</div>
